/**
 * Bootstrap principal — `new Resort(rt => {...})` care lega toate init modules.
 * Port 1:1 din legacy common.js lines 2343-2680 (callback final IIFE).
 *
 * Resort constructor asteapta DOMContentLoaded + fetch /res/interface.ro.xml
 * (incarca window.intData) inainte sa cheme acest callback.
 */

import { Resort } from '../core/resort.js';
import { initFx, initVideoSlowdown } from './fx.js';
import { initFaq, initLayerRequest } from './faq.js';
import { initMobileMenu } from './menu-mobile.js';
import { initLangMenu } from './menu-lang.js';
import { initStickyMenu } from './menu-left.js';
import { initLogin } from './login.js';
import { initGoToTop } from './goto-top.js';
import { initMisc } from './misc.js';

export function startResortBootstrap(): void {
    new Resort(() => {
        initFx();
        initVideoSlowdown();
        initFaq();
        initLayerRequest();
        initMobileMenu();
        initLangMenu();
        initLogin();
        initGoToTop();
        initStickyMenu();
        initMisc();
    });
}
